import { Tablenodatafound } from "../TableNoDataFount";
import {
  KWHText,
  WattText,
  getHrMinFormat,
  getValidData,
} from "../../../Shared/Methods";

interface props {
  Data: any;
  pageSize: number;
  pageind: number;
  PinList: any[];
}

function Consumptionreportstable({ Data, pageSize, pageind, PinList }: props) {
  const { items } = Data;

  return (
    <>
      <tr>
        <th rowSpan={2}>S.No</th>
        <th rowSpan={2} style={{ minWidth: "100px" }}>
          Date
        </th>
        <th rowSpan={2}>{`Start Reading${KWHText}`}</th>
        <th rowSpan={2}>{`Consumption${KWHText}`}</th>
        {/* <th rowSpan={2}>EB Power</th>
        <th rowSpan={2}>Generator</th>
        <th rowSpan={2}>Idle Time</th> */}
        {PinList.length > 0 ? (
          PinList.map((elem: any, index: number) => {
            return (
              <th rowSpan={2}>
                {elem.pin_name ? elem.pin_name : `Pin ${index + 1}`}
              </th>
            );
          })
        ) : (
          <>
            <th rowSpan={2}>Pin 1</th>
            <th rowSpan={2}>Pin 2</th>
            <th rowSpan={2}>Pin 3</th>
          </>
        )}

        <th colSpan={3}>Watts{WattText}</th>
        <th colSpan={3}>LN Volts</th>
        <th colSpan={3}>LL Volts</th>
        <th colSpan={3}>Amps</th>
      </tr>
      <tr style={{ position: "sticky", top: "41px" }}>
        <th>Average</th>
        <th>Minimum</th>
        <th>Maximum</th>
        <th>Average</th>
        <th>Minimum</th>
        <th>Maximum</th>
        <th>Average</th>
        <th>Minimum</th>
        <th>Maximum</th>
        <th>Average</th>
        <th>Minimum</th>
        <th>Maximum</th>
      </tr>

      {items?.length > 0 ? (
        items.map((ele: any, ind: number) => {
          return (
            <>
              <tr>
                <td rowSpan={ele?.data?.length + 1} style={{ width: 50 }}>
                  {pageind * pageSize + (ind + 1)}
                </td>
                <td rowSpan={ele?.data?.length + 1}>
                  {getValidData(ele?.date)}
                </td>
              </tr>

              {ele?.data?.map((ele: any) => {
                return (
                  <>
                    <tr>
                      <td>{getValidData(ele?.startReading)}</td>
                      <td>{getValidData(ele?.todayConsumption)}</td>

                      {/* <td>
                        {getValidData(
                          ele?.eb_duration
                            ? getHrMinFormat(ele?.eb_duration)
                            : null
                        )}
                      </td>
                      <td>
                        {getValidData(
                          ele?.dg_duration
                            ? getHrMinFormat(ele?.dg_duration)
                            : null
                        )}
                      </td>
                      <td>
                        {getValidData(
                          ele?.power_ideal_duration
                            ? getHrMinFormat(ele?.power_ideal_duration)
                            : null
                        )}
                      </td> */}

                      <td>
                        {getValidData(
                          ele?.pin_1_duration
                            ? getHrMinFormat(ele?.pin_1_duration)
                            : ""
                        )}
                      </td>
                      <td>
                        {getValidData(
                          ele?.pin_2_duration
                            ? getHrMinFormat(ele?.pin_2_duration)
                            : ""
                        )}
                      </td>
                      <td>
                        {getValidData(
                          ele?.pin_3_duration
                            ? getHrMinFormat(ele?.pin_3_duration)
                            : ""
                        )}
                      </td>

                      <td>{getValidData(ele?.avg_watt)}</td>
                      <td>{getValidData(ele?.min_watt)}</td>
                      <td>{getValidData(ele?.max_watt)}</td>

                      <td>{getValidData(ele?.avg_ln)}</td>
                      <td>{getValidData(ele?.min_ln)}</td>
                      <td>{getValidData(ele?.max_ln)}</td>

                      <td>{getValidData(ele?.avg_ll)}</td>
                      <td>{getValidData(ele?.min_ll)}</td>
                      <td>{getValidData(ele?.max_ll)}</td>

                      <td>{getValidData(ele?.avg_amps)}</td>
                      <td>{getValidData(ele?.min_amps)}</td>
                      <td>{getValidData(ele?.max_amps)}</td>
                    </tr>
                  </>
                );
              })}
            </>
          );
        })
      ) : (
        <Tablenodatafound />
      )}
    </>
  );
}

export default Consumptionreportstable;
